import axios from 'axios';
import { 
    Equipment, 
    EquipmentFilter, 
    EquipmentListResponse, 
    EquipmentType, 
    EquipmentBrand 
} from '../types/equipment';

const API_BASE_URL = '/api';

// Adicionar tipo para o formulário (pode ser mais específico)
export type EquipmentFormData = Partial<Omit<Equipment, 'id' | 'createdAt' | 'updatedAt' | 'EquipmentType' | 'EquipmentBrand' | 'CreatedBy' | 'UpdatedBy'> & {
  equipment_type_id: number | string; // IDs serão enviados
  equipment_brand_id: number | string;
}>;

class EquipmentService {
  // Buscar lista de equipamentos com paginação/filtros
  async getAll(filters?: EquipmentFilter): Promise<EquipmentListResponse> {
    try {
      const response = await axios.get<EquipmentListResponse>(`${API_BASE_URL}/equipments`, { params: filters });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar equipamentos:", error);
      throw error;
    }
  }

  // Buscar lista de tipos de equipamento ativos
  async getEquipmentTypes(): Promise<EquipmentType[]> {
    try {
      const response = await axios.get<EquipmentType[]>(`${API_BASE_URL}/equipment-types`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar tipos de equipamento:", error);
      throw error;
    }
  }

  // Buscar lista de marcas de equipamento ativos
  async getEquipmentBrands(): Promise<EquipmentBrand[]> {
    try {
      const response = await axios.get<EquipmentBrand[]>(`${API_BASE_URL}/equipment-brands`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar marcas de equipamento:", error);
      throw error;
    }
  }
  
  async getById(id: number): Promise<Equipment> {
    try {
      const response = await axios.get<Equipment>(`${API_BASE_URL}/equipments/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar equipamento com ID ${id}:`, error);
      throw new Error('Falha ao buscar dados do equipamento.');
    }
  }

  async create(equipmentData: EquipmentFormData): Promise<Equipment> {
    try {
      const response = await axios.post<Equipment>(`${API_BASE_URL}/equipments`, equipmentData);
      return response.data;
    } catch (error: any) {
      console.error("Erro ao criar equipamento:", error);
      throw new Error(error.response?.data?.error || 'Falha ao criar equipamento.');
    }
  }

  async update(id: number, equipmentData: EquipmentFormData): Promise<Equipment> {
    try {
      const response = await axios.put<Equipment>(`${API_BASE_URL}/equipments/${id}`, equipmentData);
      return response.data;
    } catch (error: any) {
      console.error(`Erro ao atualizar equipamento com ID ${id}:`, error);
      throw new Error(error.response?.data?.error || 'Falha ao atualizar equipamento.');
    }
  }

  // Adicionar delete posteriormente
  // async delete(id: number): Promise<void> { ... }
}

export default EquipmentService; 